import { combineReducers } from 'redux';

import products from './products';
import session from './session';

const reducers = { products, session };

export default combineReducers(reducers);
